import { ReactNode } from 'react'
import { twMerge } from 'src/utils/tw-merge.util'

interface DocumentNameProps {
  children: ReactNode
  className?: string
}

const DocumentName = ({ children, className }: DocumentNameProps) => (
  <span className={twMerge('c-min-w-0 c-text-sm c-font-semibold c-leading-[19px] c-text-black', className)}>
    {children}
  </span>
)

export { DocumentName }
